import React from 'react';
import __ from 'lodash';
import {connect} from 'react-redux';
import {cekCookies} from '../../actions';
import Cookies from 'js-cookie';
import history from '../../history';
import Navbar from './navbar/Navbar';
import Sidebar from './sidebar/Sidebar';
import LoaderModal from '../modal/LoaderModal';
import { Router, Route } from 'react-router-dom';
import CbtPsep from './content/report/cbt/CbtPsep';
import { CONFIG } from '../../config';
import DetailCbtReport from './content/report/cbt/detail/DetailCbtReport';
import accountManagement from '../../../src/apis/accountManagement';
import { Row, Col, Alert } from 'react-bootstrap';
import { Grid } from '@material-ui/core';

//import $ from 'jquery';
class Dashboard extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isFetching: false,
            alertShow : false,
            idRole : null, // 9 => sekolah, 10 => guru
            profil : []
        }
    }
    async componentDidMount(){
        this.setState({isFetching: true});
        await this.props.cekCookies();
        if(this.props.account.idRole === '9' || this.props.account.idRole === '10') this.profilSekolah();
        this.setState({isFetching: false});
    }

    profilSekolah = async (e)=>{
        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_HOME).catch(function(error){
        });

        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    idRole : this.props.account.idRole,
                    profil : response.data.data.profilSekolah,
                    isFetching : false
                })
            }
        }
    }

    defineRoute(){
        if(this.props.account.idRole === CONFIG.ID_ROLE_ADMIN_SEKOLAH){
            return (
                <div>
                    <Route path="/dashboard/report/cbt" exact component={CbtPsep} />
                </div>
            )
        }
    }

    hancleChange = async (e) =>{
        let key = e.target.name;
        let val = e.target.value;

        this.setState(prevState => {
            let profil = Object.assign({}, prevState.profil);
            profil[key] = val;
            return { profil };
          })
    }

    handleSubmit = async (e)=>{
        this.setState({ isFetching: true });
        e.preventDefault();
        console.log(this.state);
        const {profil} = this.state;
        const dataSend = {
            ['namaSekolah']: profil.namaSekolah,
            ['telfonSekolah']: profil.telfonSekolah,
            ['email'] : profil.emailSekolah,
            ['alamat'] : profil.alamatSekolah,
            ['tarif'] : profil.tarif,
            ['uangMasukSiswaBaru'] : profil.uangMasukSiswaBaru,
            ['logoSekolah']: profil.logoSekolah
        }
        console.info('DATA SEK DIKIRIM',dataSend);

        const respSubmit = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_UPDATE_PROFIL, dataSend)
        .catch(function(error) {
            console.error(error);
        });

        console.log(respSubmit.data.data.message);
        this.profilSekolah();


        this.setState({ 
            isFetching: false,
            alertShow: true,
            resMessage : respSubmit.data.data.message
        });




    }

    componentDidUpdate(){
        // console.clear();
    }

    render(){
        const {profil} = this.state;
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} profil={profil}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />
                    {this.loadAlert()}
                    {!__.isEmpty(profil) &&
                        <form onSubmit={this.handleSubmit}>  
                            {/* <Row>
                                <Col>
                                    <b style={{"float":"right"}}>Akses Expired : {profil.psepExpiredDate}</b>
                                </Col>
                            </Row>    */}
                            <Grid container spacing={3}>
                                {/* {this.renderLogoSekolah()} */}
                                <Grid xs={12} sm={10} md={10} lg={9} xl={9}>
                                    <Row>
                                        <Col>
                                            <div className="form-group">
                                                <label>Nama</label>
                                                <input type="text" className="form-control" name="namaSekolah" value={profil.namaSekolah}  
                                                    placeholder="Nama Sekolah" title="Nama Sekolah" required autoComplete="off" disabled/>
                                            </div>
                                        </Col>
                                    </Row> 
                                    <Row>
                                        <Col>
                                            <div className="form-group">
                                                <label>Nomor Telepon</label>
                                                <input type="text" className="form-control" name="telfonSekolah" value={profil.telfonSekolah} onChange={this.hancleChange}  
                                                    placeholder="Nomor Telepon Sekolah" title="Nomor Telepon Sekolah" required autoComplete="off"/>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="form-group">
                                                <label>Email</label>
                                                <input type="email" className="form-control" name="emailSekolah" value={profil.emailSekolah} onChange={this.hancleChange}  
                                                    placeholder="emailsekolah@domain-email.com" title="Email Sekolah" required/>
                                            </div>
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col>
                                            <div className="form-group">
                                                <label>Alamat</label>
                                                <input className="form-control" name="alamatSekolah" value={profil.alamatSekolah} onChange={this.hancleChange}  
                                                    placeholder="Alamat Sekolah" title="Alamat Sekolah" required/>
                                            </div>
                                        </Col>
                                    </Row> 
                                    
                                    
                                    {this.props.account.idRole == 9 &&
                                        <>
                                        <Row>
                                            <Col>
                                                <div className="form-group">
                                                    <label>SPP Siswa (Rp.)</label>
                                                    <input type="text" className="form-control" name="tarif" value={profil.tarif} onChange={this.hancleChange}  
                                                        placeholder="SPP siswa per bulan" required/>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group">
                                                    <label>Uang Masuk siswa (Rp.)</label>
                                                    <input type="text" className="form-control" name="uangMasukSiswaBaru" value={profil.uangMasukSiswaBaru} onChange={this.hancleChange}  
                                                        placeholder="Uang Masuk Siswa Didik Baru" required/>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>                        
                                                <button type="submit" value="Submit" className="btn btn-outline-primary">
                                                    <li className="fa fa-simpan"> Simpan</li>
                                                </button>
                                            </Col>
                                        </Row>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                            {/* <Row>
                                <Col>
                                    <div className="form-group">
                                        <label>Nama</label>
                                        <input type="text" className="form-control" name="namaSekolah" value={profil.namaSekolah}  
                                            placeholder="Nama Sekolah" title="Nama Sekolah" required autoComplete="off" disabled/>
                                    </div>
                                </Col>
                            </Row> 
                            <Row>
                                <Col>
                                    <div className="form-group">
                                        <label>Nomor Telepon</label>
                                        <input type="text" className="form-control" name="telfonSekolah" value={profil.telfonSekolah} onChange={this.hancleChange}  
                                            placeholder="Nomor Telepon Sekolah" title="Nomor Telepon Sekolah" required autoComplete="off"/>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label>Email</label>
                                        <input type="email" className="form-control" name="emailSekolah" value={profil.emailSekolah} onChange={this.hancleChange}  
                                            placeholder="emailsekolah@domain-email.com" title="Email Sekolah" required/>
                                    </div>
                                </Col>
                            </Row>  
                            <Row>
                                <Col>
                                    <div className="form-group">
                                        <label>Alamat</label>
                                        <input className="form-control" name="alamatSekolah" value={profil.alamatSekolah} onChange={this.hancleChange}  
                                            placeholder="Alamat Sekolah" title="Alamat Sekolah" required/>
                                    </div>
                                </Col>
                            </Row> 
                            
                            
                            {this.props.account.idRole == 9 &&
                                <>
                                <Row>
                                    <Col>
                                        <div className="form-group">
                                            <label>SPP Siswa (Rp.)</label>
                                            <input type="text" className="form-control" name="tarif" value={profil.tarif} onChange={this.hancleChange}  
                                                placeholder="SPP siswa per bulan" required/>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="form-group">
                                            <label>Uang Masuk siswa (Rp.)</label>
                                            <input type="text" className="form-control" name="uangMasukSiswaBaru" value={profil.uangMasukSiswaBaru} onChange={this.hancleChange}  
                                                placeholder="Uang Masuk Siswa Didik Baru" required/>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>                        
                                        <button type="submit" value="Submit" className="btn btn-outline-primary">
                                            <li className="fa fa-simpan"> Simpan</li>
                                        </button>
                                    </Col>
                                </Row>
                                </>
                            }             */}
                        </form>
                    }
                    <Router history={history}>
                        <Route path="/dashboard/report/cbt" exact render={(props) => <CbtPsep {...props} account={this.props.account} />} />
                        <Route path="/dashboard/report/cbt/detail" component={DetailCbtReport}/>
                    </Router>
                </div>
            </div>
        )
    }

    renderLogoSekolah () {
        const {profil} = this.state;
        return(
            <Grid xs={12} sm={2} md={2} lg={3} xl={3}>
                <img src={profil.logoSekolah === null ? "/image/dinas_pendidikan.png" : profil.logoSekolah} width="90%" style={{marginBottom : 10}} />
                {this.props.account.idRole == 9 && 
                    <input type="file" onChange={ (e) => this.handleChangeType(e) } accept=".png, .jpeg, .jpg" />
                }
            </Grid>
        )
    }

    handleChangeType = async (e) =>{
        console.info('FILE YANG DIKIRIM', e.target.files[0].type)


        if(e.target.files[0].size < 1000000){
            if(!e.target.files[0].type.includes('image/')){
                this.setState({ 
                    alertShow: true,
                    resMessage: 'Maaf, Gambar harus bertype png, jpg, png'
                });
            }else{
                let data = new FormData();
                data.append('file', e.target.files[0]);
                const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_UPLOAD_FOTO,
                    data
                ).catch(function(error) {
                    console.error('handleSubmit', error);
                })

                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    window.location.reload();
                }  
            }

        }else{
            this.setState({ 
                alertShow: true,
                resMessage: 'Maaf, ukuran maksimal adalah 1 MB'
            });
        }


    }

    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        } 
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Dashboard);